import type { FormData } from 'types/formData';

/** Stable string for dirty-checking full report form state. */
export function serializeFormDataForCompare(data: FormData): string {
  return JSON.stringify(data);
}

export function isFormDataEqual(a: FormData, b: FormData): boolean {
  return serializeFormDataForCompare(a) === serializeFormDataForCompare(b);
}
